/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import _, { filter } from 'lodash';
import { toast } from 'react-toastify';
import { postAgendaFilter } from '../../../api/productUtilDashboardApi';
import { getTeamV4Filter } from '../../../api/filterOptionsApi';
import { filterTeamV4Options } from '../../../helpers/filterFunctions';
import useProductUtilizationDashboardContext from '../context/useProductUtilizationDashboardContext';

export default function FilterUtil() {
  const { filterForm, setFilterForm, handleGenerateReport, handleClearReport } = useContext(
    useProductUtilizationDashboardContext,
  );

  const [teamOptions, setTeamOptions] = useState([]);
  const [agendaOptions, setAgendaOptions] = useState([]);

  const loadTeamDropdown = async () => {
    const request = {
      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
    };
    const reponse = await getTeamV4Filter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterTeamV4Options(data);
      setTeamOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadAgendaDropdown = async () => {
    const request = {
      rep_team: filterForm?.team?.value,
      date_from: filterForm?.date_from,
      date_to: filterForm?.date_to,
    };
    const reponse = await postAgendaFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.id,
        label: row.description,
      }));

      setAgendaOptions(dropdownValue);
    }
  };

  const handleChangeDate = (name, value) => {
    if (name === 'date_from') {
      setFilterForm({
        ...filterForm,
        date_from: moment(value).format('YYYY-MM-DD'),
        date_to: moment(value).endOf('month').format('YYYY-MM-DD'),
      });
    }
    if (name === 'date_to') {
      if (moment(value).format('M') !== moment(filterForm?.date_from).format('M')) {
        toast.warning('Please select date with same month..');
        return;
      }
      setFilterForm({
        ...filterForm,
        date_to: moment(value).format('YYYY-MM-DD'),
      });
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  useEffect(() => {
    loadTeamDropdown();
    loadAgendaDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='team'
            disableClearable
            fullWidth
            options={teamOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Teams' />}
            size='small'
            value={filterForm?.team}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'team')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            id='agenda'
            multiple
            fullWidth
            options={agendaOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm?.agenda ?? []}
            noOptionsText='No Agenda'
            onChange={(e, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [];
              }

              setFilterForm({
                ...filterForm,
                agenda: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Agenda' />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>
        <Grid md={1}>
          <DesktopDatePicker
            label='Date From'
            inputFormat='MM/DD/YYYY'
            value={filterForm?.date_from}
            onChange={(e) => handleChangeDate('date_from', e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={1}>
          <DesktopDatePicker
            label='Date To'
            inputFormat='MM/DD/YYYY'
            value={filterForm?.date_to}
            fullWidth
            onChange={(e) => handleChangeDate('date_to', e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateReport}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleClearReport}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
